import React, { useCallback, useContext, useEffect } from 'react';
import { SET_TEST_DURATION, TEST_CONFIGURATION } from '../../utils/Constants';
import InputboxLabel from '../../components/InputboxLabel';
import { ABContext } from '../../contexts/ABContext';
import { TPayload } from '../../types/ab';
import Typography from 'Components/DesignSystem/Typography/Typography';

const TestConfiguration = () => {

    const abContext = useContext(ABContext);

    useEffect(() => {
        if (abContext?.setPayload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                test_duration: prevPayload?.test_duration ?? 0
            }));
        }
    }, [abContext?.setPayload]);

    const handleTestDurationChange = useCallback((newTestDuration: number) => {
        if (abContext?.payload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                test_duration: newTestDuration
            }));
        }
    }, []);

    return (
        <div>
            {/* A section heading that was a `<label>` with no `htmlFor`, hardcoded to
                14px/600 — which is exactly the `title-header` token. */}
            <Typography variant="title-header" as="h2" className="tw-text-ink tw-mb-3">
                {TEST_CONFIGURATION}
            </Typography>
            <div className='tw-flex tw-items-start tw-gap-10'>
                <div className='tw-w-[15%] tw-text-ink'>
                    <InputboxLabel data-testid="detail-test-duration" label={SET_TEST_DURATION} showAdditionalLabel={true} onChange={handleTestDurationChange} initialValue={abContext?.payload?.test_duration != null ? Math.ceil(abContext?.payload?.test_duration) : 1} />
                </div>
            </div>
        </div>
    );
}

export default TestConfiguration;